import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Alert, Grid, Spinner, Text } from "~/components-shared";
import trendReportSelectors from "~/store/trendReports/selectors";
import TrendOverviewFootprintsCard from "~/components/TrendOverviewFootprintsCard";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import TrendOverviewResourcesCard from "~/components/TrendOverviewResourcesCard";
import styled from "styled-components";
import authSelectors from "~/store/auth/selectors";
import lists from "~/lib/lists";
import { AuthoritiesEnum, MemberDepartmentEnum, MemberLevelEnum } from "~/types/enums";
import useAbacExt from "~/hooks/abac";
const Wrapper = styled.div`
  flex-direction: column;
  height: 100%;
  display: flex;
  align-items: start;
`;
const TopicTrendOverviewContent = () => {
  const {
    t
  } = useTranslation();
  const selected = useSelector(trendReportSelectors.getSelected);
  const [report] = useState(selected);
  const selectedData = useSelector(trendReportSelectors.getSelectedData);
  const [trendId] = useState(selectedData);
  const trend = report?.trends.find(_ref => {
    let {
      id
    } = _ref;
    return id === trendId;
  });
  const reportId = report?.id || "";
  const error = useSelector(trendReportSelectors.getErrorByTrendFollow(trendId));
  const [footprintLoading, setFootprintLoading] = useState(false);
  const [footprintError, setFootprintError] = useState("");
  const [footprints, setFootprints] = useState([]);
  const user = useSelector(authSelectors.getUser);
  const {
    userHas
  } = useAbacExt();
  const matrix = userHas(AuthoritiesEnum.EXPERIMENTAL) ? {
    technicality: 1,
    detail: 0
  } : lists.members.quadrant.matrix[`${user.department || MemberDepartmentEnum.PRODUCT}|${user.level || MemberLevelEnum.IC}`];
  const initialStyle = trend?.styles?.find(style => style.technicality === matrix.technicality && style.detail === matrix.detail) || undefined;
  useEffect(() => {
    if (report && trend) {
      setFootprintLoading(true);
      setFootprintError("");
      api.fetchTopicTrendFootprints(report.id, trend.id).then(f => setFootprints(f)).catch(e => setFootprintError(handleError(e))).finally(() => {
        setFootprintLoading(false);
      });
    }
  }, [reportId, trendId]);
  return /*#__PURE__*/React.createElement(Wrapper, null, (error || footprintError) && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error || footprintError), trend && report ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3"
  }, t("TopicTrendOverviewContent.description")), /*#__PURE__*/React.createElement(Text, {
    element: "p",
    color: "textSecondary",
    fontSize: 4,
    lineHeight: 6,
    s: {
      mb: 5,
      mt: 2
    }
  }, initialStyle?.description || trend.theme.description || "No description"), footprintLoading ? /*#__PURE__*/React.createElement(Spinner, {
    center: true,
    s: {
      my: 6
    }
  }) : footprints.length ? /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    equal: true,
    gap: 3,
    style: {
      overflow: "hidden"
    },
    fullWidth: true
  }, /*#__PURE__*/React.createElement(TrendOverviewResourcesCard, {
    report: report,
    trend: trend,
    footprints: footprints,
    fullWidth: true,
    style: {
      overflow: "auto",
      height: "100%"
    }
  }), /*#__PURE__*/React.createElement(TrendOverviewFootprintsCard, {
    report: report,
    trend: trend,
    footprints: footprints,
    fullWidth: true,
    style: {
      overflow: "auto",
      height: "100%"
    }
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mb: 3
    }
  }, "Ooops!"), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    color: "textSecondary",
    weight: "semiBold"
  }, "No relevant Footprints found for this Topic"))) : /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    color: "textSecondary"
  }, "Ooops! Something went wrong"));
};
export default TopicTrendOverviewContent;